import React from 'react'

import { splitProps } from '@/utils/collections'

import FormField, { FormFieldProps, FormlessFormField } from '../FormField'
import DatePicker, { DatePickerProps } from '../Input/DatePicker/DatePicker'

export default class DatePickerFormField extends React.PureComponent<
	Omit<DatePickerProps, 'onChange'> & FormFieldProps & { formless?: boolean }
> {
	render() {
		const fieldProps = { ...this.props }

		const inputProps = splitProps(fieldProps, [
			'placeholder',
			'autoFocus',
			'minDate'
		])

		const FF = this.props.formless ? FormlessFormField : FormField

		return (
			<FF {...fieldProps}>
				<DatePicker {...inputProps} />
			</FF>
		)
	}
}
